// The price per m² that goes with a variant's selling price (the sale price
// when on sale, otherwise the regular price). Same rule as the backend's
// pricePerM2After (product.service.ts), which applies it on Inventory saves:
//  - crates and packs (coverage 1 m² or more): selling price / coverage;
//  - single slabs and panels (under 1 m²): their stored coverage is rounded
//    (a 290x290 slab is 0.09, really 0.0841), so the saved price per m² is
//    moved by the same percentage as the selling price instead.
// null = no answer (no coverage or no price) - leave the field as it is.

type Prices = { price: unknown; discPrice: unknown; approxCoverage: unknown; priceMS?: unknown };

const selling = (v: Prices) => (Number(v.discPrice) > 0 ? Number(v.discPrice) : Number(v.price));
const round2 = (n: number) => Math.round(n * 100) / 100;

export function pricePerM2(saved: Prices | null, now: Prices): number | null {
  const coverage = Number(now.approxCoverage) || 0;
  const newSelling = selling(now);
  if (!(coverage > 0) || !(newSelling > 0)) return null;
  const sameCoverage = saved && Number(saved.approxCoverage) === coverage;
  if (coverage < 1 && saved && sameCoverage && Number(saved.priceMS) > 0 && selling(saved) > 0) {
    return round2(Number(saved.priceMS) * (newSelling / selling(saved)));
  }
  return round2(newSelling / coverage);
}
